<template>
  <div class="page">
    <transition
      appear
      name="opbouwanimatie"
      mode="out-in"
      v-bind:css="false"
      v-on:enter="enter"
    >
      <main>
        <div class="ovalyellow stappen"></div>
        <div class="ovalgreen stappen"></div>
        <div class="line_header"></div>
        <div class="rightdown"></div>
        <div class="leftdown"></div>
        <levensweg-header icon="?"></levensweg-header>
        <header>
          <pager class="pager" start="3" end="04" />
          <h2 class="titleslide stappen">Étudiant.e</h2>
          <p class="bodyslide stappen">
            Combien d'années supplémentaires souhaites-tu étudier ?
          </p>
        </header>
        <section class="selectstudytime">
          <flickity ref="flickity" :options="flickityOptions">
            <div class="carousel-cell">01</div>
            <div class="carousel-cell">02</div>
            <div class="carousel-cell">03</div>
            <div class="carousel-cell">04</div>
            <div class="carousel-cell">05</div>
          </flickity>
        </section>
        <levensweg-button
          class="backButton"
          label="Précédent"
          color="orange left"
          link="/stap3"
        />
        <levensweg-button
          class="nextButton"
          label="Suivant"
          color="orange right"
          link="/stap4"
        />
        <div class="swipehand">
          <img src="./../assets/img/swipe_hand.svg" />
          <p class="swipetext">Swipe pour sélectionner</p>
        </div>
      </main>
    </transition>
  </div>
</template>

<script>
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";
import Pager from "./../components/Pager";
import Flickity from "./../components/Vue-Slider";
import { TimelineMax, Sine, Expo } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
// Force CSSPlugin to not get dropped during build
//need this to avoid tree shake of CSSPlugin
/* eslint-disable */
const plugins = [CSSPlugin];
/* eslint-enable */
let tl;

export default {
  components: {
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton,
    pager: Pager,
    flickity: Flickity,
  },

  beforeRouteLeave(to, from, next) {
    let selectedIndex = this.$refs.flickity.selectedIndex();
    let verderstuderen = selectedIndex + 1;
    //save in the store
    this.$store.commit("setVerderStuderen", verderstuderen);
    //console.log(this.$store.state.verderstuderen);
    //

    let outroline = new TimelineMax({ paused: true });
    outroline
      .to(".titleslide", 1, { opacity: 0, ease: Sine.easeIn })
      .to(".titleslide", 0.5, { x: 50, ease: Sine.easeOut }, "-=0.8")
      .to(".bodyslide", 1, { x: 50, opacity: 0, ease: Expo.easeOut }, "-=0.6")
      .to(
        ".selectstudytime",
        0.8,
        { x: 50, opacity: 0, ease: Expo.easeOut },
        "-=0.6"
      );
    outroline.eventCallback("onComplete", () => {
      //console.log("outro ready");
      next();
    });
    outroline.timeScale(1.3);
    outroline.play();
  },

  methods: {
    enter: function (el, done) {
      tl = new TimelineMax({ paused: true });
      //const ornaHeight = document.querySelector(".line_header").clientHeight;
      //const ornaWidth = document.querySelector(".line_header").clientWidth;

      tl.add("enter");
      //tl.from(".pager",1,{opacity:0,ease:Sine.easeIn})
      //.from(".pager",0.5,{x:50,ease:Sine.easeOut},"-=0.8")
      tl.from(".titleslide", 1, { opacity: 0, ease: Sine.easeIn })
        .from(".titleslide", 0.5, { x: 50, ease: Sine.easeOut }, "-=0.8")
        //.fromTo(".line_header",1.5,{clip:`rect(0px, ${ornaWidth}px, 0px, 0px)`},{clip:`rect(0px, ${ornaWidth}px, ${ornaHeight}px, 0px)`, ease:Expo.easeOut},"-=0.5")
        .from(
          ".bodyslide",
          0.8,
          { x: 50, opacity: 0, ease: Expo.easeOut },
          "-=0.6"
        )
        .from(
          ".selectstudytime",
          0.8,
          { x: 50, opacity: 0, ease: Expo.easeOut },
          "-=0.6"
        );
      //.fromTo(".ovalyellow",1.5,{scale:0, transformOrigin:"0% 0%"},{scale:1, ease:Elastic.easeOut.config(1,0.8)},"-=0.7")
      //.fromTo(".ovalgreen",1.5,{scale:0, transformOrigin:"100% 100%"},{scale:1, ease:Elastic.easeOut.config(1,0.8)},"-=0.8")
      tl.timeScale(1.3);
      //tl.delay(1.6);
      tl.eventCallback("onComplete", () => {
        //console.log("intro ready");
        done();
      });
      tl.play();
    },
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 1,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
      },
    };
  },
};
</script>

<style>
.swipehand {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 46px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.swipetext {
  display: none;
}

.line_header {
  background-image: url("../assets/img/line_small.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 128px;
  height: 89.8px;
  left: 20px;
  position: absolute;
  z-index: -1;
}

.rightdown {
  background-image: url("../assets/img/right.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 114.2px;
  height: 140.5px;
  position: absolute;
  z-index: -1;
  bottom: 0px;
  right: 0px;
}

.leftdown {
  background-image: url("../assets/img/left.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 99.4px;
  height: 166px;
  position: absolute;
  z-index: -1;
  bottom: 0px;
  left: 0px;
}

.ovalyellow.stappen {
  background-image: url("../assets/img/homehalfovalyellow.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 106px;
  height: 273px;
  position: absolute;
  z-index: -2;
  filter: brightness(0) saturate(100%) invert(100%) sepia(11%) saturate(0%)
    hue-rotate(50deg) brightness(105%) contrast(101%);
}

.ovalgreen.stappen {
  background-image: url("../assets/img/homehalfovalgreen.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 97px;
  height: 327px;
  position: absolute;
  bottom: 25px;
  right: 0px;
  z-index: -1;
  filter: brightness(0) saturate(100%) invert(100%) sepia(11%) saturate(0%)
    hue-rotate(50deg) brightness(105%) contrast(101%);
}
.backButton {
  /*margin: 2.2rem 1.8rem 3rem 1.8rem;*/
  position: absolute;
  bottom: 30px;
  left: 18px;
}
.nextButton {
  position: absolute;
  bottom: 30px;
  right: 18px;
}

.stappen {
  margin-top: 0;
}

.pager {
  margin-top: 10.7rem;
  margin-left: 1.7rem;
}

.bodyslide {
  margin-top: 1.5rem;
}

.carousel-cell {
  font-family: "Playfair Display";
  font-size: 8.5rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.88;
  letter-spacing: normal;
  color: var(--slidernotselected);
  margin-right: 4rem;
  padding-bottom: 2rem;
  padding-top: 1rem;
}
.flickity-slider .is-selected {
  color: var(--greenoverlay);
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
    height: 550px;
  }
  .swipehand img {
    margin-right: 1.6rem;
  }

  .swipetext {
    display: block;
  }
}

@media only screen and (min-width: 992px) {
  .swipetext {
    font-size: 1.4rem;
  }

  .ovalyellow.stappen {
    background-image: url("../assets/img/oval_left_big_step.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 335px;
    height: 705px;
    position: absolute;
    z-index: -2;
    margin-top: -5px;
  }

  .ovalgreen.stappen {
    background-image: url("../assets/img/oval_right_big_step.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 366px;
    height: 518px;
    top: 0;
  }

  .page {
    position: relative;
    height: 700px;
  }
  .titleslide.stappen {
    margin-left: 25rem;
  }
  .pager {
    margin-top: 9.3rem;
    margin-left: 20.1rem;
  }
  .bodyslide.stappen {
    margin-left: 25rem;
  }
}
@media only screen and (min-width: 1200px) {
  .carousel-cell {
    font-size: 13.75rem;
  }

  .ovalyellow.stappen {
    width: 335px;
    height: 705px;
    margin-top: 6.3rem;
  }

  .line_header {
    width: 128px;
    height: 139.8px;
    left: unset;
  }

  .page {
    height: 768px;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }

  .backButton {
    left: 88px;
  }

  .nextButton {
    right: 88px;
  }

  .leftdown {
    width: 131px;
    height: 218px;
  }

  .rightdown {
    width: 149px;
    height: 179px;
  }
}
</style>
